import { render, staticRenderFns } from "./Receive.vue?vue&type=template&id=4630e279&scoped=true&"
import script from "./Receive.vue?vue&type=script&lang=js&"
export * from "./Receive.vue?vue&type=script&lang=js&"
import style0 from "./Receive.vue?vue&type=style&index=0&id=4630e279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4630e279",
  null
  
)

export default component.exports